import TableResult from './tableResult'

export default TableResult
